<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="delzhgl-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            账户管理
          </div>
          <div v-loading="accountLoading" class="card-content">
            <el-table
              :data="accountData"
              :show-header="false"
              :row-style="{cursor: 'pointer'}"
              style="width: 100%"
              @row-click="openDetails"
            >
              <el-table-column
                v-if="!isSingleAccount"
                label="账户名称"
                width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#000;">{{ scope.row.accountname }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="账户余额"
                width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#99a9bf;">账户余额：</span>
                  <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ scope.row.balance }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="总收入"
                width="160"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#99a9bf;">总收入：</span>
                  <span style="color:#67C23A;">+ {{ scope.row.totalRevenue }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="总支出"
                width="160"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#99a9bf;">总支出：</span>
                  <span style="color:#F56C6C;">- {{ scope.row.totalExpenses }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="本月收入"
                width="160"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#99a9bf;">本月收入：</span>
                  <span style="color:#67C23A;">+ {{ scope.row.monthRevenue }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="本月支出"
                min-width="160"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#99a9bf;">本月支出：</span>
                  <span style="color:#F56C6C;">- {{ scope.row.monthExpenses }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
      <el-col class="card" style="margin-top: 20px">
        <div class="card-body">
          <div class="card-title">
            打款申请
            <el-button type="primary" class="add-btn" icon="el-icon-plus" @click="editApply('0')">添加申请</el-button>
            <div class="search-mode">
              <input v-model="search" type="text" class="search-input" placeholder="关键字搜索">
              <el-button class="search-btn" icon="el-icon-search" @click="Search" />
            </div>
          </div>
          <div class="card-content">
            <el-row>
              <el-col :span="5">
                <ul class="group-filter">
                  <!-- <li :class="type===-1?'active':''" @click="change(-1)">全部</li> -->
                  <li :class="type===0?'active':''" @click="change(0)">审核中</li>
                  <li :class="type===2?'active':''" @click="change(2)">审核通过</li>
                  <li :class="type===1?'active':''" @click="change(1)">审核拒绝</li>
                </ul>
              </el-col>
              <el-col v-loading="loading" :span="19">
                <el-table
                  :data="tableData"
                  :show-header="false"
                  style="width: 100%"
                >
                  <el-table-column
                    label="打款账户"
                    :width="isSingleAccount?220:280"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.mark===0" :disable-transitions="true" size="mini" type="warning">待审核</el-tag>
                      <el-tag v-if="scope.row.mark===2" :disable-transitions="true" size="mini">审核通过</el-tag>
                      <el-tag v-if="scope.row.mark===1" :disable-transitions="true" size="mini" type="danger">审核拒绝</el-tag>
                      <span v-if="!isSingleAccount" style="color:#000;margin-left: 6px;">{{ scope.row.account_name }}</span>
                      <span style="color:#000;margin-left: 6px;">{{ scope.row.ranum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="单号"
                    width="220"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.paycontent == '账户充值'">账户充值</span>
                      <template v-else>
                        <span v-if="scope.row.ordernum!==null&&scope.row.ordernum!==''&&scope.row.ordernum!==undefined" style="color:#99a9bf">订单号：</span>
                        <span v-if="scope.row.ordernum!==null&&scope.row.ordernum!==''&&scope.row.ordernum!==undefined">
                          {{ scope.row.ordernum }}
                          /
                          <span v-if="scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined" style="font-weight: 500;color:#409EFF">{{ scope.row.produnum }}</span>
                          <span v-if="scope.row.produnum===null||scope.row.produnum===''||scope.row.produnum===undefined" style="font-weight: 500;color:#999999">N/A</span>
                        </span>
                        <span v-if="scope.row.manum!==null&&scope.row.manum!==''&&scope.row.manum!==undefined" style="color:#99a9bf">物料单号：</span>
                        <span v-if="scope.row.manum!==null&&scope.row.manum!==''&&scope.row.manum!==undefined">{{ scope.row.manum }}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="打款性质"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">性质：</span>
                      <span>{{ scope.row.nature }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="打款日期"
                    width="110"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span><i class="el-icon-time" /> {{ scope.row.time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请人"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">申请人：</span>{{ scope.row.user_name }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="卡号"
                    min-width="180"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span><i class="el-icon-bank-card" /> {{ scope.row.card }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="打款金额"
                    width="100"
                    fixed="right"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ scope.row.amount }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-dropdown v-if="scope.row.mark!==2 && user.name == scope.row.user_name" size="mini" split-button icon="el-icon-edit" @click="editApply(scope.row.apply_id)">
                        <i class="el-icon-edit" /> 编辑
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item style="color:#F56C6C" @click.native="delApply(scope.row.apply_id)"><i class="el-icon-delete" /> 删除申请</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-button v-else size="mini" icon="el-icon-search" @click="view(scope.row)">查看申请</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" v-loading="infoLoading" :model="editForm" :rules="editRules" label-position="right" label-width="90px" size="small">
        <el-form-item v-if="audittime!==null&&audittime!==''" label="审核信息">
          <el-card class="box-card">
            <div style="color:#606266;font-size: 13px;">
              <span><span style="color:#99a9bf">审核时间：</span>{{ audittime }}</span>
              <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{ auditname }}</span>
            </div>
            <div v-if="auditrson!=''&&auditrson!=null" style="color:#606266;font-size: 13px;">
              <span style="color:#99a9bf">拒绝原因：</span>{{ auditrson }}
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="经销商" prop="delid">
          <el-input v-model="user.delname" :disabled="true" />
        </el-form-item>
        <el-form-item label="打款账户" prop="aid">
          <el-select v-model="editForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="gitem in groupList"
              v-if="gitem.nature===0 && (!isSingleAccount || gitem.groupid === accountData[0].groupid)"
              :key="gitem.groupid"
              :label="gitem.account_name"
            >
              <el-option
                v-for="item in accountsList"
                v-if="item.groupid===gitem.groupid"
                :key="item.aid"
                :label="item.name+'（'+item.card+'）'"
                :value="item.aid"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="打款性质" prop="nature">
          <el-select v-model="editForm.nature">
            <el-option
              v-for="item in receiptNatureList"
              :key="item.rntid"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="打款日期" prop="receipttime">
          <el-date-picker
            v-model="editForm.receipttime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="打款金额" prop="money">
          <el-input v-model="editForm.money" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="卡号" prop="card">
          <el-input v-model="editForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit />
        </el-form-item>
        <el-form-item label="打款凭证" prop="imgids">
          <MultiImg :key="imgLoad" v-model="editForm.imgids" :limit="9" :size="'sm'" :old="editimgList" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="editForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="打款申请"
      :visible.sync="viewVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewdata.applyname }}</td>
          <th>申请时间</th>
          <td>{{ viewdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewdata.delname }}</td>
          <th>卡号</th>
          <td>{{ viewdata.card }}</td>
        </tr>
        <tr>
          <th>流水号</th>
          <td>{{ viewdata.ranum }}</td>
          <th v-if="viewdata.orderid!==null&&viewdata.orderid!==''&&viewdata.orderid!==undefined">订单号</th>
          <td v-if="viewdata.orderid!==null&&viewdata.orderid!==''&&viewdata.orderid!==undefined"><span style="color:#409EFF;cursor: pointer" @click="goOrder(viewdata.orderid)"><i class="el-icon-document"></i> {{ viewdata.ordernum }} / {{ viewdata.produnum }}</span></td>
          <th v-if="viewdata.maid!==null&&viewdata.maid!==''&&viewdata.maid!==undefined">物料单号</th>
          <td v-if="viewdata.maid!==null&&viewdata.maid!==''&&viewdata.maid!==undefined">{{ viewdata.manum }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="3">{{ viewdata.account }}</td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ viewdata.receipttime }}</td>
          <th>打款性质</th>
          <td>{{ viewdata.nature }}</td>
        </tr>
        <tr>
          <th>打款内容</th>
          <td>{{ viewdata.paycontent }}</td>
          <th>打款金额</th>
          <td colspan="3" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ viewdata.money }}</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in imgSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;  margin-right: 10px; margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ viewdata.remark }}</td>
        </tr>
        <tr>
          <th>审核人</th>
          <td>{{ viewdata.auditname }}</td>
          <th>审核时间</th>
          <td>{{ viewdata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="receiptTitle"
      :visible.sync="receiptVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form size="small" :inline="true" :model="receiptForm" label-width="70px">
        <el-form-item label="收支类型" prop="type">
          <el-select v-model="receiptForm.type" style="width: 100px" clearable>
            <el-option label="收入" value="1" />
            <el-option label="支出" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="关键字" prop="content">
          <el-input v-model="receiptForm.content" autocomplete="off" />
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" @click="searchReceipt">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="receiptData"
        :show-header="false"
        style="width: 100%"
      >
        <el-table-column
          label="时间"
          width="170"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span><i class="el-icon-time" /> {{ scope.row.time }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="收支金额"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type===1" style="color:#67C23A;font-weight: 500">+ {{ scope.row.money }}</span>
            <span v-if="scope.row.type===0" style="color:#F56C6C;font-weight: 500">- {{ scope.row.money }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="收支说明"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="receiptForm.total>0"
        style="margin-top: 20px"
        background
        :current-page="receiptForm.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="receiptForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="receiptForm.total"
        @size-change="handleSizeChangeReceipt"
        @current-change="handleCurrentChangeReceipt"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerAccountData, getDealerAccountReceipt } from '@/api/dealer'
import { getCollectionApplyList, getReceiptNature, addOrEditCollectApply, addCollectionInfo, deleteCollect } from '@/api/erp'
import { getAccounts, getGroupReport } from '@/api/pub'
import MultiImg from '@/components/upload/MultiImg'

export default {
  name: 'delzhgl',
  components: {
    MultiImg
  },
  data() {
    return {
      accountLoading: false,
      accountData: [],
      viewVisible: false,
      viewLoading: false,
      imgSrcList: [],
      viewdata: [],
      fullscreenLoading: false,
      editTitle: '添加打款申请',
      groupList: [],
      receiptNatureList: [],
      accountsList: [],
      imgLoad: '',
      editimgList: [],
      search: '',
      type: 0,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      audittime: '',
      auditname: '',
      auditrson: '',
      infoLoading: false,
      editForm: {
        raid: '',
        delid: '',
        aid: null,
        receipttime: '',
        money: null,
        card: '',
        nature: '',
        remark: '',
        imgids: []
      },
      editRules: {
        delid: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        aid: [{ required: true, message: '请选择打款账户', trigger: 'change' }],
        receipttime: [{ required: true, message: '请选择打款日期', trigger: 'change' }],
        money: [{ required: true, message: '请输入打款金额', trigger: 'blur' }],
        card: [{ required: true, message: '请输入卡号', trigger: 'blur' }],
        nature: [{ required: true, message: '请选择打款性质', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }]
      },
      editloading: false,
      receiptForm: {
        accid: null,
        content: '',
        type: null,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      receiptloading: false,
      receiptVisible: false,
      receiptTitle: '',
      receiptData: [],
      isSingleAccount: true
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.accountLoading = true
    getDealerAccountData({ delid: this.user.delid }).then(response => {
      this.accountData = response.data
      if (this.accountData.length > 1) {
        this.isSingleAccount = false
      }
      this.accountLoading = false
    }).catch(() => {
      this.accountLoading = false
    })
    this.getData()
    getGroupReport().then(response => {
      this.groupList = response.data
    }).catch(() => {})
    getAccounts().then(response => {
      this.accountsList = response.data
    }).catch(() => {})
    getReceiptNature().then(response => {
      this.receiptNatureList = response.data
    }).catch(() => {})
  },
  methods: {
    goOrder(orderid) {
      this.viewVisible = false
      this.$router.push({ path: '/work/delorder/' + orderid })
    },
    change(n) {
      if (this.type === n) {
        return false
      }
      this.type = n
      this.getData()
    },
    Search() {
      if (this.search !== null && this.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        mark: this.type === -1 ? null : this.type,
        content: this.search,
        page: this.currentPage,
        limit: this.pageSize,
        delid: this.user.delid,
        groupid: this.user.dGroupid
      }
      getCollectionApplyList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    editApply(id) {
      if (id === '0') {
        this.editTitle = '添加打款申请'
        this.editForm.raid = '0'
        this.editForm.delid = this.user.delid
        this.editForm.aid = null
        this.editForm.receipttime = ''
        this.editForm.money = null
        this.editForm.card = ''
        this.editForm.nature = ''
        this.editForm.remark = ''
        this.editForm.imgids = []
        this.editimgList = []
        this.audittime = ''
        this.auditname = ''
        this.auditrson = ''
        this.imgLoad = new Date().getTime()
      } else {
        this.editTitle = '编辑打款申请'
        this.infoLoading = true
        addCollectionInfo({ userid: this.user.userid, applyid: id }).then(response => {
          this.editForm.raid = response.data.ra.raid
          this.editForm.delid = response.data.ra.delid
          this.editForm.aid = response.data.ra.aid
          this.editForm.receipttime = response.data.ra.receipttime
          this.editForm.money = response.data.ra.money
          this.editForm.card = response.data.ra.card
          this.editForm.nature = response.data.ra.nature
          this.editForm.remark = response.data.ra.remark
          this.audittime = response.data.ra.audittime
          this.auditname = response.data.ra.auditname
          this.auditrson = response.data.ra.rson
          let oldimgList = []
          for (let img of response.data.applyInfo.imgs) {
            oldimgList.push({ id: img.img_id, url: img.img_url })
          }
          this.editimgList = oldimgList
          this.imgLoad = new Date().getTime()
          this.infoLoading = false
        }).catch(() => {
          this.infoLoading = false
        })
      }
      this.editVisible = true
    },
    delApply(id) {
      this.$confirm('删除此打款申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        deleteCollect({ userid: this.user.userid, applyid: id }).then(response => {
          this.fullscreenLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getData()
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {})
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              userid: this.user.userid,
              role: 0,
              applyid: this.editForm.raid,
              dealerid: this.editForm.delid,
              date: this.editForm.receipttime,
              money: this.editForm.money,
              accountid: this.editForm.aid,
              card: this.editForm.card,
              nature: this.editForm.nature,
              imgStr: this.editForm.imgids.join(','),
              remark: this.editForm.remark,
              paycontent: '账户充值'
            }
            addOrEditCollectApply(data).then(response => {
              this.$message({
                message: '打款申请提交成功',
                type: 'success'
              })
              this.editVisible = false
              this.editloading = false
              this.editimgList = []
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    view(row) {
      console.log(row.user_name)
      console.log(this.user.name)
      this.imgSrcList = []
      this.viewVisible = true
      this.viewLoading = true
      addCollectionInfo({ userid: this.user.userid, applyid: row.apply_id }).then(response => {
        this.viewLoading = false
        this.viewdata = response.data.ra
        this.viewdata.applyname = row.user_name
        this.viewdata.delname = row.all_name
        let account = ''
        for (let a of response.data.accountList) {
          if (a.is_select === 1) {
            account = a.account_name + '（' + a.card + '）'
            break
          }
        }
        this.viewdata.account = account
        let imgs = []
        for (let c of response.data.applyInfo.imgs) {
          imgs.push(c.img_url)
        }
        this.imgSrcList = imgs
      }).catch(() => {
        this.viewLoading = false
      })
    },
    openDetails(row) {
      this.receiptForm.accid = row.accid
      this.receiptForm.content = ''
      this.receiptForm.type = null
      this.receiptForm.currentPage = 1
      this.receiptForm.pageSize = 10
      this.receiptForm.total = 0
      this.receiptTitle = row.accountname + ' - 收支记录'
      this.receiptVisible = true
      this.getAccountReceipt()
    },
    searchReceipt() {
      this.receiptForm.currentPage = 1
      this.getAccountReceipt()
    },
    handleSizeChangeReceipt(val) {
      this.receiptForm.pageSize = val
      this.getAccountReceipt()
    },
    handleCurrentChangeReceipt(val) {
      this.receiptForm.currentPage = val
      this.getAccountReceipt()
    },
    getAccountReceipt() {
      this.receiptloading = true
      const data = {
        accid: this.receiptForm.accid,
        content: this.receiptForm.content,
        type: this.receiptForm.type,
        page: this.receiptForm.currentPage,
        limit: this.receiptForm.pageSize
      }
      getDealerAccountReceipt(data).then(response => {
        this.receiptData = response.data
        this.receiptForm.total = response.total
        this.receiptloading = false
      }).catch(() => {
        this.receiptloading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.delzhgl-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .add-btn{
            position: relative;
            float: right;
            margin-left: 10px;
            margin-top: -10px;
          }
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
